export default "__VITE_ASSET__JGP$Zxxv__"